import { createAsyncThunk } from '@reduxjs/toolkit';
import { TestimonyProgramServices } from 'Services/axios/TestimonyProgram.Service';
import { toast } from 'react-toastify';
import { handleApiError } from 'Features/Common/ErrorHandler';

export const fetchTestimonyProgram = createAsyncThunk(
  'TestimonyProgram/fetchTestimonyProgram',
  async (filters) => {
    try {
      const response = await TestimonyProgramServices.getAll(filters);
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const submitTestimonyProgram = createAsyncThunk(
  'addTestimonyProgram/submitTestimonyProgram',
  async (data) => {
    try {
      const formData = new FormData();
      formData.append('name', data?.name);
      let response;
      if (data.isUpdate) {
        response = await TestimonyProgramServices.update(data?.id, formData);
      } else {
        response = await TestimonyProgramServices.create(formData);
      }
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      data.successCallback && data.successCallback();
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const deleteTestimonyProgram = createAsyncThunk(
  'deleteTestimonyProgram/deleteTestimonyProgram',
  async (id) => {
    try {
      const response = await TestimonyProgramServices.delete(id);
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const submitAssets = createAsyncThunk(
  'addAssets/submitAssets',
  async (data) => {
    try {
      const formData = new FormData();
      data?.assets?.forEach((asset) => {
        formData.append(`files[]`, asset);
      });
      let response;
      response = await TestimonyProgramServices.createAssets(formData, data?.id);
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      data?.successCallback && data?.successCallback();
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const deleteAssets = createAsyncThunk(
  'deleteAssets/deleteAssets',
  async (id) => {
    try {
      const response = await TestimonyProgramServices.deleteAssets(id);
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const attachDetachTestimonyProgram = createAsyncThunk(
  'attachDetachTestimonyProgram/attachDetachTestimonyProgram',
  async (data) => {
    try {
      const formData = new FormData();
      data?.main_program_ids?.forEach((mainProgram) => {
        formData.append(`main_program_ids[]`, mainProgram);
      });
      await TestimonyProgramServices.attachDetach(data.id, formData);
      return true;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const orderTestimonyProgram = createAsyncThunk(
  'orderTestimonyProgram/orderTestimonyProgram',
  async (data) => {
    try {
      const formData = new FormData();
      data?.ids?.forEach((mainProgram) => {
        formData.append(`ids[]`, mainProgram);
      });
      await TestimonyProgramServices.order(data.id, formData);
      return true;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

/* **************************************************** */
/* Pagination                                           */
/* **************************************************** */

export const handleBackPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
  if (pagination.current_page > 1) {
    dispatch(setFilters({
      ...filters,
      page: pagination.current_page - 1
    }));
    setRefetch(prevRefetch => !prevRefetch);
  }
}

export const handleNextPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
  if (pagination.current_page < pagination.last_page) {
    dispatch(setFilters({
      ...filters,
      page: pagination.current_page + 1
    }));
    setRefetch(prevRefetch => !prevRefetch);
  }
}

export const handleClickPagination = (page, filters, dispatch, setFilters, setRefetch) => {
  dispatch(setFilters({
    ...filters,
    page: page
  }));
  setRefetch(prevRefetch => !prevRefetch);
}